import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import Select from 'react-select'
import './SelectorNoForm.css';

interface props {
    style?: StyleSheet;
    options: string[];
    value: string | { value: string, label: string } | null;
    onChange?: (newValue: unknown) => void;
}

const SelectorNoForm = ({ style, options: unMappedOptions, value: unMappedValue, onChange }: props) => {
    const options = (unMappedOptions || []).map(option => ({ value: option, label: option }));
    const [value, setValue] = useState('' as string | null);
    useEffect(() => {
        if (typeof unMappedValue == "string") { if (unMappedValue) setValue(unMappedValue); }
        else setValue(unMappedValue?.value || null);
    }, [unMappedValue])
    return <Select style={style} classNamePrefix="selector-no-form"options={options} value={{ value: value, label: value }} onChange={(params) => {
        if (params?.value === 'Clear') setValue(null);
        setValue(params?.value || null);
        if (onChange instanceof Function) onChange(params);
    }} />
}
export default SelectorNoForm